// CROSSSELL-109 — Store V2 language preference (UA default / EN optional).

export type StoreV2Lang = "ua" | "en";

export const STORE_V2_LANG_KEY = "asiastyle.store-v2.lang.v1";
export const DEFAULT_STORE_V2_LANG: StoreV2Lang = "ua";

export function normalizeStoreV2Lang(raw: string | null | undefined): StoreV2Lang {
  const v = String(raw ?? "").trim().toLowerCase();
  if (v === "en" || v === "eng" || v === "english") return "en";
  return "ua";
}

export function readStoreV2Lang(): StoreV2Lang {
  try {
    return normalizeStoreV2Lang(window.localStorage.getItem(STORE_V2_LANG_KEY));
  } catch {
    return DEFAULT_STORE_V2_LANG;
  }
}

export function writeStoreV2Lang(lang: StoreV2Lang): void {
  try {
    window.localStorage.setItem(STORE_V2_LANG_KEY, lang);
  } catch {
    /* ignore */
  }
}
